import React from 'react';
import type { ButtonHTMLAttributes } from 'react';
import { ReactComponent as StarBkg } from './img/bxs-star-bkg.svg';
import { ReactComponent as Star } from './img/bx-star.svg';
import { ReactComponent as FixBkg } from './img/fix-bkg.svg';
import { ReactComponent as Fix } from './img/fix.svg';
import { Tooltip } from '@lk-gtcom/ecomlab-components';
import { MoonLoader } from 'react-spinners';
import './ButtonWithIcon.scss';

type PredefinedSize = 'xs' | 's' | 'm';
type CustomSize = string;

interface ButtonWithIconProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode | string;
  label?: string;
  size?: PredefinedSize | CustomSize;
  className?: string
  onClick?: (e: any) => void;
  count?: number | false;
  blue?: boolean
  orange?: boolean
  red?: boolean
  green?: boolean
  whiteBlue?: boolean
  violet?: boolean
  action?: boolean
  whiteGreen?: boolean
  grey?: boolean
  lilac?: boolean
  white?: boolean
  darkViolet?: boolean
  style?: object,
  // Дефолтные иконки
  pin?: boolean,
  favorite?: boolean,
  changeValue?: boolean
  round?: boolean
  loading?: boolean
}

export const ButtonWithIcon = ({
  icon,
  label,
  size = 's',
  onClick,
  className = '',
  count = false,
  blue = false,
  orange = false,
  red = false,
  green = false,
  whiteBlue = false,
  grey = false,
  violet = false,
  lilac = false,
  action = false,
  white = false,
  whiteGreen = false,
  darkViolet = false,
  style = {},
  // Дефолтные иконки
  favorite = false,
  pin = false,
  changeValue = false,
  round = false,
  loading = false
}: ButtonWithIconProps) => {

  const returnIcon = () => {
    if (favorite) return changeValue ? <StarBkg /> : <Star />
    if (pin) return changeValue ? <FixBkg /> : <Fix />
  }

  const colorClassName = () => {
    if (blue) return 'blue-btnIcon'
    if (whiteBlue) return 'white-blue-btnIcon'
    if (green) return 'green-btnIcon'
    if (orange) return 'orange-btnIcon'
    if (red) return 'red-btnIcon'
    if (grey) return 'grey-btnIcon'
    if (violet) return 'violet-btnIcon'
    if (lilac) return 'lilac-btnIcon'
    if (action) return 'action-btnIcon'
    if (white) return 'white-btnIcon'
    if (whiteGreen) return 'white-green-btnIcon'
    if (darkViolet) return 'dark-violet-btnIcon'
  }

  // Если задается собственный размер, то используем его
  const buttonSize =
    size === 'xs' || size === 's' || size === 'm'
      ? `var(--${size})`
      : `${size}px`;

  const renderedIcon =
    typeof icon === 'string' ? (
      <img src={icon} alt={label || 'icon'} className={`button-with-icon__icon ${className}`} />
    ) : (
      returnIcon() || icon
    );

  // Элемент кнопки
  const buttonElement = <button
    className={`button-with-icon__btn ${className ?? ''} ${colorClassName()}`}
    style={{
      width: buttonSize,
      height: buttonSize,
      borderRadius: size === 'xs' || size <= '20' ? '4px' : (round ? '50%' : ''),
    }}
    onClick={onClick}
    type="button"
  >
    {loading
      ?
      <div className="btn-basic__loading">
        <MoonLoader
          color="#474747ff"
          speedMultiplier={0.5}
          size={'20'}
        />
      </div>
      :
      renderedIcon
    }
  </button>

  return (
    <div className={'button-with-icon'}
      style={style}
    >
      {count ? <span className="button-with-icon__count">{count}</span> : null}

      {label ?
        <Tooltip
          text={label ? label : ''}
          maxWidth='110px'
          theme='light'
          child={buttonElement}
        />
        :
        buttonElement
      }
    </div>
  );
};
